import React, { useEffect, useState, useMemo, useRef } from "react";
import { connect } from "react-redux";
import styled, { createGlobalStyle, keyframes } from "styled-components";
import Tabs from "app/popleads/components/ui-kit/Tabs";
import ProfileCard, {
    fallbackSrc,
    Image,
    ImageBorder,
    ImageSection,
    StyledTooltip,
} from "app/popleads/modules/extension/components/ProfileCard";
import { Dropdown, OverlayTrigger } from "react-bootstrap";
import Spinner from "app/popleads/components/ui-kit/Spinner";
import { colors } from "app/popleads/components/ui-kit/colors";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import ExtensionAboutPage from "./components/ExtensionAboutPage";
import Modal from "app/popleads/components/ui-kit/Modal";
import { ExtensionProvider, useExtensionContext } from "./ExtensionContext";
import { POPUP_CONTENTS } from "./utils/constants";
import ExtensionCoursesPage from "./components/ExtensionCoursesPage";
import ExtensionDealsPage from "./components/ExtensionDealsPage";
import ExtensionNewDealPage from "./components/ExtensionNewDealPage";
import TypeTag from "app/popleads/modules/extension/components/TypeTag";
import ButtonWithLabel from "app/popleads/components/ui-kit/ButtonWithLabel";
import ExtensionCourseCard from "./components/ExtensionCourseCard";
import ExtensionDealCard from "./components/ExtensionDealCard";
import ExtensionNoteCard from "./components/ExtensionNoteCard";
import ExtensionNewTaskPage from "./components/ExtensionNewTaskPage";
import ExtensionTaskCard from "./components/ExtensionTaskCard";
import useTaskDelete from "app/popleads/hooks/useTaskDelete";
import useUnpopProfile from "app/popleads/hooks/useUnpopProfile";
import ExtensionTaskList from "./components/ExtensionTaskList";
import ExtensionFeedList from "./components/ExtensionFeedList";
import { toast, ToastContainer, cssTransition } from "react-toastify";
import useGetLinkedInExtensionConfigs from "app/popleads/hooks/useGetLinkedInExtensionConfigs";
import ExtensionFilesAndAttachments from "./components/ExtensionFilesAndAttachments";
import ExtensionNewLead from "./components/ExtensionNewLead";
import ExtensionProfileTasksPage from "./components/ExtensionProfileTasksPage";
import { DealFooter } from "./components/DealFooter";
import ExtensionHeaderActions from "./components/ExtensionHeaderActions";
import ExtensionCainNotificationToasts from "./components/ExtensionCainNotificationToasts";
import { get } from "../../../popleads/networking/RequestService";
import * as auth from "../../../modules/Auth/_redux/authRedux";
import { createCookie, eraseCookie } from "app/popleads/app/functions/util";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "_metronic/_helpers";
import DOMPurify from "dompurify";
import { useSelector } from "react-redux";
import useSetProfileKeyContact from "app/popleads/hooks/useSetProfileKeyContact";
import ExtensionNotice from "./components/ExtensionNotice";
import ExtensionAIAssistantPage from "./components/ExtensionAIAssistantPage";
import ExtensionAssistantPage from "./components/assistant/ExtensionAssistantPage";
import ExtensionAssistantLauncher from "./components/assistant/ExtensionAssistantLauncher";
import { canAskAssistant } from "app/popleads/components/Chat/assistantAccess";

const headerHeight = 47;
//const profileContentHeight = 155;

const GlobalStyle = createGlobalStyle`
  body {
    background-color: transparent !important;
    /* extensionu iframe'de açarken, arkaplanın şeffaf olması için ileride değiştirilecekç */
    
    @media (max-width: 450px) {
        /* Bootstrap tooltip: Ensures the tooltip and its arrow remain visible on small screens */
        .tooltip {
            .arrow,
            .tooltip-inner {
                display: block !important;
            }
        }
    }
        
    @media (min-width: 451px) {
        .Toastify__toast-container {
            width: 300px;
            padding: 0;
            right: 0;
            margin: 0;
        }
        .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
            top: 0;
            transform: translateX(0);
        }
        .Toastify__toast {
            margin-bottom: 0;
            border-radius: 0;
        }
    }

    *::-webkit-scrollbar {
        width: 9px;
    }

    *::-webkit-scrollbar-thumb {
        background-color: ${colors.neutral[500]};
        border-radius: 9px;
        border: 3px solid transparent;
        background-clip: content-box;
        min-height: 58px;
    }

    *::-webkit-scrollbar-thumb:hover {
        background-color: ${colors.neutral[700]};
    }

    *::-webkit-scrollbar-corner {
        background-color: ${colors.neutral[100]};
    }
}`;

const ExtensionContainer = styled.div`
    min-width: 300px;
    width: 300px;
    height: calc(100%);
    display: flex;
    flex-direction: column;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
`;

const ExtensionContentWrapper = styled.div`
    width: 100%;
    height: calc(100vh - ${headerHeight}px);
    background-color: #f8f8fc;
    border-radius: 0 0 8px 8px;
    padding: 12px 0px;
    position: relative;
    display: flex;
    flex-direction: column;

    /* The assistant orb floats at this wrapper's bottom-left corner. Its room is not taken from the
       wrapper: a band reserved here shrank only the tabs that size themselves off it (Feed, Profile)
       and left a dead strip under them, while Tasks' footer — absolute, at bottom: 0 — ignored it and
       sat under the orb anyway. Instead each tab's scroller ends on this much extra space, so its last
       item can be scrolled clear of the orb, and the orb steps over the footers tabs pin down. */
    --assistant-orb-space: ${(props) => (props.reserveAssistantSpace ? "72px" : "0px")};
    --assistant-orb-bottom: 14px;

    /* Tasks pins a 48px bar (Overdues / Only Completed) to the bottom: the orb sits above it. */
    &:has([data-tasks-footer]) {
        --assistant-orb-bottom: 60px;
    }

    /* With tasks selected, the bulk-action bar stacks on top of that one; the orb steps aside
       rather than covering its buttons. */
    &:has([data-tasks-bulk-actions]) [data-assistant-orb] {
        display: none;
    }
`;

/*const ExtensionFooter = styled.div`
    width: 100%;
    min-height: 50px;
    background-color: #fff;
    border-radius: 0 0 8px 8px;
`;*/

const ExpandingPopup = styled.div`
    visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
    width: ${(props) =>
        props.variant && props.isOpen
            ? props.variant === "Deals" ||
              props.variant === "Transfer Deal" ||
              props.variant === "New Deal" ||
              props.variant === "Notes" ||
              props.variant === "Profile Tasks" ||
              props.variant === "About" ||
              props.variant === "Campaigns" ||
              props.variant === "Certified AI Native" ||
              props.variant === "AI Assistant"
                ? "662px"
                : "412px"
            : "0px"};
    height: 100%;
    background-color: #f8f8fc;
    margin-right: ${(props) => (props.isOpen ? "8" : "0")}px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow-x: hidden;
    transition: width 0.9s ease, margin-right 0s linear ${(props) => (props.isOpen ? "0s" : "0.9s")},
        visibility 0s linear ${(props) => (props.isOpen ? "0s" : "0.9s")};
`;

const ExtensionPopup = styled.div`
    width: ${(props) =>
        props.variant
            ? props.variant === "Deals" ||
              props.variant === "Transfer Deal" ||
              props.variant === "New Deal" ||
              props.variant === "Notes" ||
              props.variant === "Profile Tasks" ||
              props.variant === "About" ||
              props.variant === "Campaigns" ||
              props.variant === "Certified AI Native" ||
              props.variant === "AI Assistant"
                ? "662px"
                : "412px"
            : "0px"};
    height: 100%;
`;

const ExtensionWithPopup = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: ${(props) => (props.isIframe ? "end" : "center")};
    font-family: "Gilroy", sans-serif !important;
    position: relative;
`;

/* react-toastify's built-in transitions (Slide/Bounce/Zoom/Flip) default to a ~750ms
   exit animation, plus a further height-collapse pass, before a closed toast is
   actually removed from the DOM — the sibling promoted to nth-child(1) can't render
   its front-card state until that's done. We don't need the collapse half of that:
   our stack is absolutely positioned, not flow-based, so there's nothing to collapse.
   These keyframes give the toast its own quick fade/scale instead. */
const toastEnterAnimation = keyframes`
    from { opacity: 0; transform: scale(0.9); }
    to { opacity: 1; transform: scale(1); }
`;

const toastExitAnimation = keyframes`
    from { opacity: 1; transform: scale(1); }
    to { opacity: 0; transform: scale(0.9); }
`;

const cainToastTransition = cssTransition({
    enter: "cain-toast-enter",
    exit: "cain-toast-exit",
    collapse: false,
});

/* Positioned relative to ExtensionWithPopup (not the page) so the CAIN notification
   toasts stay centred over the widget regardless of where the surrounding page puts it. */
const CainNotificationToastLayer = styled.div`
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 20;

    /* newestOnTop puts the newest toast first in the DOM: it's the front card, older
       ones fan out behind it. Every toast stays absolutely positioned at all times —
       when the front toast closes and the next one is promoted to nth-child(1), only
       its opacity/transform/z-index change (all continuously transitionable). Letting
       nth-child(1) switch to a relative position used to make the promoted toast
       render stuck at its old (translucent, scaled-down) paint until something like a
       mousemove forced a repaint — a Chromium compositing glitch triggered by animating
       opacity across a layout-mode change in the same frame. */
    .Toastify__toast-container {
        position: absolute;
        top: 12px;
        left: 50%;
        transform: translateX(-50%);
        width: 280px;
        padding: 0;
        pointer-events: auto;
    }

    .Toastify__toast {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 0;
        border: 1px solid ${colors.neutral[200]};
        border-radius: 10px;
        box-shadow: 0px 2px 6px rgba(28, 52, 62, 0.16);
        opacity: 1;
        transform: scale(1) translateY(0);
        z-index: 3;
        transition: transform 0.18s ease, opacity 0.18s ease, background-color 0.18s ease;
    }

    .Toastify__toast:nth-child(2) {
        transform: scale(0.96) translateY(-16px);
        background-color: ${colors.neutral[50]};
        box-shadow: 0px 4px 10px rgba(28, 52, 62, 0.22);
        opacity: 1;
        z-index: 2;
    }

    .Toastify__toast:nth-child(3) {
        transform: scale(0.92) translateY(-28px);
        background-color: ${colors.neutral[100]};
        box-shadow: 0px 4px 10px rgba(28, 52, 62, 0.22);
        opacity: 1;
        z-index: 1;
    }

    .Toastify__toast:nth-child(n + 4) {
        display: none;
    }

    .cain-toast-enter {
        animation: ${toastEnterAnimation} 0.2s ease;
    }

    .cain-toast-exit {
        animation: ${toastExitAnimation} 0.15s ease;
    }
`;

const ExtensionPopupHeader = styled.div`
    width: 100%;
    height: 56px;
    background-color: #fff;
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid ${colors.neutral[100]};
`;

const ExtensionPopupHeaderTitle = styled.div`
    color: ${colors.neutral[700]};
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    letter-spacing: -0.13px;
`;

const ExtensionPopupContent = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: ${(props) =>
        props.variant === "New Deal" || props.variant === "Transfer Deal"
            ? "calc(100% - 56px)"
            : props.variant === "Deals"
            ? "calc(100% - 56px - 50px)"
            : props.variant === "Campaigns"
            ? "calc(100% - 56px - 24px)"
            : props.variant === "Notes"
            ? "calc(100% - 56px)"
            : props.variant === "New Task"
            ? "calc(100% - 56px)"
            : props.variant === "About"
            ? "calc(100% - 56px)"
            : props.variant === "Profile Tasks"
            ? "calc(100% - 56px - 50px)"
            : props.variant === "Certified AI Native" || props.variant === "AI Assistant"
            ? "calc(100% - 56px)"
            : "calc(100% - 56px - 50px - 24px)"};
    background-color: #f8f8fc;

    ${(props) =>
        props.variant === "New Task" || props.variant === "Notes"
            ? `border-radius: 0 0 8px 8px; 
        border-bottom: 1px solid ${colors.neutral[100]};
        overflow: hidden;`
            : ""}
`;

const ExtensionPopupFooter = styled.div`
    width: 100%;
    height: 50px;
    background-color: ${colors.white};
    padding: 8px 12px;
    border-top: 1px solid ${colors.neutral[100]};
    border-radius: 0 0 8px 8px;
`;

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #384d567a;
    z-index: 1000;
`;

export const InputWrapper = styled.div`
    width: 100%;
    position: fixed;
    max-width: 275px;
    z-index: 1001;
    margin: 0 auto;
`;

export const ProfileLoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ isSolidBackground }) => (isSolidBackground ? "#fff" : "rgba(255, 255, 255, 0.8)")};
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
`;

const MailContentModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
`;

const MailContentContainer = styled.div`
    width: 80%;
    max-width: 800px;
    max-height: 80vh;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

const MailContentHeader = styled.div`
    padding: 16px;
    border-bottom: 1px solid ${colors.neutral[200]};
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const MailContentBody = styled.div`
    padding: 16px;
    overflow-y: auto;
    flex: 1;
    i {
        color: inherit;
        font-size: inherit;
    }
`;

export const StyledDropdownToggle = styled(Dropdown.Toggle)`
    background: none !important;
    border: none !important;
    padding: 0 !important;
    color: inherit !important;
    box-shadow: none !important;

    &:hover,
    &:active,
    &:focus {
        background: none !important;
        border: none !important;
        box-shadow: none !important;
        color: inherit !important;
    }

    &:after {
        display: none !important;
    }
`;

export const StyledDropdownMenu = styled(Dropdown.Menu)`
    padding: 8px;
    min-width: 180px;
    max-width: max-content;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 1px solid ${colors.neutral[200]};

    .dropdown-item {
        border-radius: 4px;
        padding: 8px 12px;
        font-size: 14px;

        &:hover {
            background-color: ${colors.neutral[100]};
        }

        &:active {
            background-color: ${colors.l3rnTech[100]};
            color: ${colors.l3rnTech[700]};
        }
    }

    .dropdown-divider {
        margin: 4px 0;
        border-color: ${colors.neutral[200]};
    }
`;

export const StyledDropdownItem = styled(Dropdown.Item)`
    display: flex !important;
    align-items: center !important;
    gap: 16px !important;
    svg {
        height: 16px !important;
        width: 16px !important;
    }
`;

const NotificationBubble = styled.span`
    background-color: ${colors.l3rnTech[600]};
    color: white;
    border-radius: 30px;
    padding: 0 4px;
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    min-width: 15px;
    width: max-content;
    position: absolute;
    top: -6px;
    left: 48px;
    cursor: pointer;

    &:hover {
        background-color: ${colors.l3rnTech[800]};
    }
`;

const TabWithNotification = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0 8px;
`;

const LoadingSalesNavigatorContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    padding: 20px;
`;

const LogoContainer = styled.div`
    margin-bottom: 30px;
    width: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const LoadingTextContainer = styled.div`
    margin-top: 20px;
    font-size: 14px;
    color: ${colors.neutral[600]};
`;

const FloatingNameBox = styled.div`
    position: sticky;
    top: 0;
    width: 100%;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    height: 75px;
    padding: 0px 10px;
    gap: 10px;
    transition: all 0.3s ease;
    z-index: 100;
    border-bottom: 1px solid ${colors.neutral[200]};
    opacity: ${(props) => (props.show ? 1 : 0)};
    transform: translateY(${(props) => (props.show ? "0" : "-60px")});
    pointer-events: ${(props) => (props.show ? "auto" : "none")};
`;

const FloatingName = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: ${colors.neutral[900]};
    line-height: 18px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    cursor: pointer;
    width: max-content;
`;

const FloatingTitle = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: ${colors.neutral[600]};
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    cursor: pointer;
    width: max-content;
`;

function ExtensionHomeContent(props) {
    const {
        selectedTab,
        popupContent,
        popupIsOpen,
        setState,
        profile,
        setProfile,
        loading,
        isProfileLoading,
        updateProfileLoading,
        selectedModal,
        modals,
        selectedDate,
        isProfileNotFound,
        showMailModal,
        mailContent,
        closeMailModal,
        isPopitSearch,
        setNewLeadObject,
        modalMessage,
        editMode,
        refreshTaskList,
        refetchTaskList,
        handleDeleteDeal,
        selectedDeal,
        initialDealObject,
        taskList,
        taskListLoading,
        fetchTaskLists,
        handleUpdateProfile,
        updateProfileParams,
        isIframeOpen,
        wonDeals,
        fetchWonDealsByAccountId,
        isRedirectingToDeal,
        showOverdueTasks,
        typeTagRef,
        taskRef,
    } = useExtensionContext();

    const { user: loggedInUser } = useSelector((state) => state.auth);

    const urlParams = new URLSearchParams(window.location.search);
    const extParam = urlParams.get("ext");

    /* CAIN's header icon stays CAIN's, on LEAD_AI_SUGGESTION_ACCESS. The assistant's orb is a
       separate door with its own permission, the same one as the CRM's window — see assistantAccess. */
    const canAsk = canAskAssistant(loggedInUser);

    /* The assistant opens in the extension's own popup — `popupContent`/`popupIsOpen` — so there is
       no second open flag to keep in step with the width this component posts to the host page. */
    const isAssistantOpen = popupIsOpen && popupContent === POPUP_CONTENTS.ASSISTANT;
    const isGenerateNewLead = ["1", "true"].includes((urlParams.get("generateNewLead") || "").toLowerCase());

    useEffect(() => {
        // Title'ı değiştir
        document.title = "L3RN Tech";

        // Favicon'u değiştir
        const favicon = document.querySelector("link[rel*='icon']") || document.createElement("link");
        favicon.type = "image/x-icon";
        favicon.rel = "shortcut icon";
        favicon.href = "/media/l3rn-tech/L3RN-Tech-38x38px.png";
        document.getElementsByTagName("head")[0].appendChild(favicon);
    }, []);

    const popupRef = useRef(null);
    const { deleteTask } = useTaskDelete();
    const [taskToDelete, setTaskToDelete] = useState(null);
    const { unpopProfile } = useUnpopProfile(profile?.id);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const isActive = false;
    const { getConfigs } = useGetLinkedInExtensionConfigs();
    const [showFilesAndAttachments, setShowFilesAndAttachments] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);
    const previousAccountIdRef = useRef(null);

    const [isUserLoaded, setUserLoaded] = useState(0);
    const [isError, setIsError] = useState(false);
    const [isLoadingSalesNavigator, setIsLoadingSalesNavigator] = useState(false);
    const [isKeyContactModalOpen, setIsKeyContactModalOpen] = useState(false);
    const { setProfileKeyContact } = useSetProfileKeyContact();
    const mailContentRef = useRef(null);
    const [showFloatingName, setShowFloatingName] = useState(false);

    useEffect(() => {
        const profileContainer = document.getElementById("profile-container");

        const handleScroll = () => {
            if (profileContainer?.scrollTop > 75) {
                setShowFloatingName(true);
            } else {
                setShowFloatingName(false);
            }
        };

        if (profileContainer) {
            profileContainer.addEventListener("scroll", handleScroll);
        }

        handleScroll();

        return () => {
            if (profileContainer) {
                profileContainer.removeEventListener("scroll", handleScroll);
            }
        };
    }, [selectedTab]);

    useEffect(() => {
        if (profile && loggedInUser) {
            const isKeyContactManager = loggedInUser?.permissions?.KEYCONTACT_MANAGER === 1;
            const showApprovalModal = profile?.keyContactStatus === 1 || profile?.keyContactStatus === 3;
            setIsKeyContactModalOpen(isKeyContactManager && showApprovalModal);
        }
    }, [profile, loggedInUser]);

    useEffect(() => {
        if (!isUserLoaded) {
            get("getLoggedinUser")
                .then(({ data: { user } }) => {
                    props.setUser(user);
                    setUserLoaded(true);
                })
                .catch((error) => {
                    setIsError(true);
                });
        }
    }, [isUserLoaded, props]);

    useEffect(() => {
        if (profile?.accountId && previousAccountIdRef.current !== profile.accountId) {
            previousAccountIdRef.current = profile.accountId;
            fetchWonDealsByAccountId(profile.accountId);
        }
    }, [profile]);

    useEffect(() => {
        if (isError) {
            toast.error("An error occurred while fetching user information.");
        }
    }, [isError]);

    useEffect(() => {
        if (refreshTaskList) {
            fetchTaskLists({ selectedDate, forceRefresh: true });
            setState((prevState) => ({
                ...prevState,
                refreshTaskList: false,
            }));
        }
    }, [refreshTaskList, selectedDate, fetchTaskLists, setState]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const extParam = urlParams.get("ext");

        if (extParam) {
            const [, hash] = extParam.split(":");

            getConfigs().then((response) => {
                if (response?.data?.extensionSeverScriptVersion !== hash) {
                    window.parent.postMessage({ message: "MESSAGE_RELOAD_EXTENSION" }, "*");
                }
            });
        }
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const hasParam = urlParams.has("is_loading_salesnavigator");
        const paramValue = urlParams.get("is_loading_salesnavigator");
        setIsLoadingSalesNavigator(hasParam && paramValue === "true");
    }, []);

    const sendNotification = (task) => {
        window.parent.postMessage({ message: "XPIDER_MESSAGE_NOTIFICATION", task: task }, "*");
    };

    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        return doc.body.textContent || "";
    };

    useEffect(() => {
        if (taskList?.gorev?.length > 0 || profile?.gorev?.length > 0) {
            const currentDate = new Date().getTime();
            const importantTasks =
                taskList?.gorev?.filter((task) => task && task.important === 1 && task.zaman > currentDate) || [];
            const importantProfileTasks =
                profile?.gorev?.filter((task) => task && task.important === 1 && task.zaman > currentDate) || [];
            importantTasks.forEach((task) => {
                if (task) {
                    sendNotification({
                        id: task.id,
                        profilId: task.profilId,
                        metin: stripHtmlTags(task.metin || ""),
                        zaman: task.zaman,
                        important: task.important,
                        customerHappiness: task.customerHappiness,
                        taskColour: task.taskColour,
                        assignedToIds: task.assignedToIds || [],
                        activityId: task.activityId || null,
                    });
                }
            });
            importantProfileTasks.forEach((task) => {
                if (task) {
                    sendNotification({
                        id: task.id,
                        profilId: task.profilId,
                        metin: stripHtmlTags(task.metin || ""),
                        zaman: task.zaman,
                        important: task.important,
                        customerHappiness: task.customerHappiness,
                        taskColour: task.taskColour,
                        assignedToIds: task.assignedToIds || [],
                        activityId: task.activityId || null,
                    });
                }
            });
        }
    }, [taskList, profile]);

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data.message) {
                if (event.data.message === "XPIDER_NOTIFICATION_DISPLAYED") {
                    if (event.data.counter && event.data.counter > 0) {
                        setNotificationCount(event.data.counter);
                        createCookie("XPIDER_DISPLAYED_TASKS_COUNTER", event.data.counter, 14);
                    } else {
                        setNotificationCount(0);
                        eraseCookie("XPIDER_DISPLAYED_TASKS_COUNTER");
                    }
                }
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    const handleTaskDelete = async (id) => {
        try {
            await deleteTask(id);

            fetchTaskLists({ selectedDate });
            //refetchProfile();
            refetchTaskList();
            toast.success("Task successfully deleted");
        } catch (error) {
            toast.error("Error deleting task");
        }
    };
    const handleProfileDelete = async () => {
        try {
            const { error } = await unpopProfile();
            if (!error) {
                toast.success("Profile successfully deleted");
                //refetchProfile();
                refetchTaskList();
            } else {
                toast.error(error);
            }
        } catch (error) {
            toast.error(error?.message || "An error occurred while deleting the profile");
        } finally {
            setIsDeleteModalOpen(false);
        }
    };

    const handleKeyContactStatusChange = async (action) => {
        setIsKeyContactModalOpen(false);
        const keyContactStatus = profile?.keyContactStatus;
        const option =
            action === "approve"
                ? keyContactStatus === 1
                    ? "enable"
                    : "disable"
                : keyContactStatus === 1
                ? "disable"
                : "enable";
        const status = action === "approve" ? (keyContactStatus === 1 ? 2 : 0) : keyContactStatus === 1 ? 0 : 2;
        const result = await setProfileKeyContact(option, status);
        if (result && result.data && result.data.profil) {
            setProfile((prevProfile) => ({
                ...prevProfile,
                keyContactStatus: result.data.profil.keyContactStatus,
            }));
            toast.success("Key-Contact status was successfully updated.");
        }
    };

    const options = useMemo(
        () => [
            { value: "Feed" },
            { value: "Profile", disabled: Boolean(isProfileNotFound || isGenerateNewLead) },
            {
                value: "Tasks",
                component: (
                    <TabWithNotification>
                        {" "}
                        Tasks{" "}
                        {notificationCount > 0 && (
                            <NotificationBubble
                                onClick={(e) => {
                                    e.stopPropagation();
                                    window.parent.postMessage(
                                        { message: "XPIDER_NOTIFICATION_DISPLAY_AGAIN", counter: notificationCount },
                                        "*"
                                    );
                                    eraseCookie("XPIDER_DISPLAYED_TASKS_COUNTER");
                                    setNotificationCount(0);
                                    fetchTaskLists({ selectedDate, forceRefresh: true });
                                }}
                            >
                                {" "}
                                {notificationCount}{" "}
                            </NotificationBubble>
                        )}
                    </TabWithNotification>
                ),
            },
        ],
        [isProfileNotFound, isGenerateNewLead, notificationCount, selectedDate, fetchTaskLists]
    );

    useEffect(() => {
        if (selectedTab === "Tasks" && !isActive && !showOverdueTasks) {
            fetchTaskLists({ selectedDate });
        }
    }, [selectedTab, selectedDate, isActive, showOverdueTasks, fetchTaskLists]);

    useEffect(() => {
        if (isLoadingSalesNavigator) {
            window.parent.postMessage(
                {
                    message: "XPIDER_MESSAGE_IFRAME_WIDTH",
                    width: 300, // En baz default değer
                },
                "*"
            );
            return;
        }

        if (isIframeOpen || isRedirectingToDeal) {
            window.parent.postMessage(
                {
                    message: "XPIDER_MESSAGE_IFRAME_WIDTH",
                    width: "100vw",
                },
                "*"
            );
            return;
        }

        if (!popupRef.current && !popupContent) {
            window.parent.postMessage(
                {
                    message: "XPIDER_MESSAGE_IFRAME_WIDTH",
                    width: 300,
                },
                "*"
            );
            return;
        }

        const POPUP_WIDTHS = {
            Deals: 662,
            "New Deal": 662,
            "Transfer Deal": 662,
            Notes: 662,
            "Profile Tasks": 662,
            About: 662,
            Campaigns: 662,
            "Certified AI Native": 662,
            "AI Assistant": 662,
            default: 412,
        };

        const getPopupWidth = (contentType) => {
            // console.log("Calculating width for content type:", contentType);
            if (!contentType) return 0;
            return POPUP_WIDTHS[contentType] || POPUP_WIDTHS.default;
        };

        let resizeTimeout;
        const updateParentWidth = (width) => {
            if (resizeTimeout) clearTimeout(resizeTimeout);
            if (popupIsOpen) {
                window.parent.postMessage(
                    {
                        message: "XPIDER_MESSAGE_IFRAME_WIDTH",
                        width: width + 308,
                    },
                    "*"
                );
            } else {
                resizeTimeout = setTimeout(() => {
                    window.parent.postMessage(
                        {
                            message: "XPIDER_MESSAGE_IFRAME_WIDTH",
                            width: 308,
                        },
                        "*"
                    );
                }, 1000); // 1000ms gecikme
            }
        };

        const initialWidth = getPopupWidth(popupContent);
        updateParentWidth(initialWidth);

        const resizeObserver = new ResizeObserver(() => {
            const width = getPopupWidth(popupContent);
            updateParentWidth(width);
        });

        resizeObserver.observe(popupRef.current);

        return () => {
            resizeObserver.disconnect();
            if (resizeTimeout) clearTimeout(resizeTimeout);
            if (!popupIsOpen) {
                window.parent.postMessage(
                    {
                        message: "XPIDER_MESSAGE_IFRAME_WIDTH",
                        width: 300,
                    },
                    "*"
                );
            }
        };
    }, [popupContent, isIframeOpen, isLoadingSalesNavigator, isRedirectingToDeal, popupIsOpen]);

    const setIsPopitSearch = (isOpen) => {
        setState((prevState) => ({ ...prevState, isPopitSearch: isOpen }));
        setNewLeadObject(null);
    };

    const toggleSearch = () => {
        setIsSearchVisible(!isSearchVisible);
        setIsPopitSearch(false);
        setNewLeadObject(null);
    };

    const searchInputOptionClick = (id) => {
        window.open(`/extension?profileId=${id}`, "_blank");
    };

    useEffect(() => {
        if (showMailModal) {
            const fullSizeBtn = mailContentRef.current?.querySelector("#fullsize");

            const handleClick = () => {
                const newWindow = window.open("", "_blank");

                if (newWindow) {
                    const doc = newWindow.document;
                    const newMailContent = doc.createElement("div");
                    newMailContent.innerHTML = DOMPurify.sanitize(mailContent, { ADD_ATTR: ["target", "rel"] });

                    const subject = newMailContent.querySelector("#subject").textContent;

                    const title = doc.createElement("title");
                    title.innerText = `L3RN Tech | ${subject ? subject : "No Subject"}`;
                    doc.head.appendChild(title);

                    const favicon = doc.createElement("link");
                    favicon.rel = "icon";
                    favicon.href = "/media/l3rn-tech/L3RN-Tech-38x38px.png";
                    favicon.type = "image/x-icon";
                    doc.head.appendChild(favicon);
                    const style = document.createElement("style");
                    style.textContent = `hr {border: 0; border-top: 1px solid rgba(0, 0, 0, 0.1);}`;
                    doc.head.appendChild(style);

                    const fullsizeElement = newMailContent.querySelector("#fullsize");
                    if (fullsizeElement) fullsizeElement.remove();
                    doc.body.appendChild(newMailContent);
                }
            };

            if (fullSizeBtn) {
                fullSizeBtn.addEventListener("click", handleClick);
            }
            // Cleanup
            return () => {
                if (fullSizeBtn) {
                    fullSizeBtn.removeEventListener("click", handleClick);
                }
            };
        }
    }, [showMailModal]);

    // const getProfileContentHeight = () => {
    //     const fullName = `${profile?.ad || ""} ${profile?.soyad || ""}`;
    //     if (fullName?.length > 25) {
    //         return 189;
    //     }

    //     return 165;
    // };

    const LoadingSalesNavigator = () => {
        return (
            <LoadingSalesNavigatorContainer>
                <LogoContainer>
                    <SVG src={toAbsoluteUrl("/media/l3rn-tech/L3RNTechBlack.svg")} height={36} />
                </LogoContainer>
                <Spinner size={32} thickness={4} variant="l3rnTech" />
                <LoadingTextContainer>Please wait while loading..</LoadingTextContainer>
            </LoadingSalesNavigatorContainer>
        );
    };

    const handleScrollToTop = () => {
        const profileContainer = document.getElementById("profile-container");
        if (profileContainer) {
            profileContainer.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    };

    if (loggedInUser && loggedInUser?.company?.whitelist === 0 && extParam) {
        return <ExtensionNotice />;
    }

    return (
        <>
            <GlobalStyle />
            {loggedInUser && <ExtensionCainNotificationToasts />}
            <ExtensionWithPopup isIframe={window.self !== window.top}>
                <CainNotificationToastLayer>
                    <ToastContainer
                        containerId="cainNotifications"
                        enableMultiContainer
                        position="top-center"
                        hideProgressBar
                        closeButton={false}
                        newestOnTop
                        transition={cainToastTransition}
                    />
                </CainNotificationToastLayer>
                <ExpandingPopup variant={popupContent} isOpen={popupIsOpen}>
                    <ExtensionPopup ref={popupRef} variant={popupContent} isOpen={popupIsOpen}>
                        <ExtensionPopupHeader>
                            <div className="d-flex align-items-center">
                                <ExtensionPopupHeaderTitle>
                                    {popupContent === POPUP_CONTENTS.NEW_TASK && editMode
                                        ? POPUP_CONTENTS.EDIT_TASK
                                        : popupContent === POPUP_CONTENTS.NOTES
                                        ? "Attachments"
                                        : popupContent}
                                </ExtensionPopupHeaderTitle>
                                {/*
                                {popupContent === POPUP_CONTENTS.AI_ASSISTANT && (
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <StyledTooltip style={{ maxWidth: "250px" }}>
                                                Courses are recommended based on user profile information, including
                                                your job title, company, industry, department, and professional
                                                headline.
                                            </StyledTooltip>
                                        }
                                    >
                                        <span style={{ color: colors.l3rnTech[500] }}>
                                            <i
                                                className="flaticon2-information icon-xs errorIcon"
                                                style={{
                                                    marginLeft: "8px",
                                                    cursor: "pointer",
                                                    color: colors.l3rnTech[900],
                                                    verticalAlign: "middle",
                                                    display: "inline-flex",
                                                    alignItems: "baseline",
                                                }}
                                            />
                                        </span>
                                    </OverlayTrigger>
                                )}
                                */}
                                {popupContent === POPUP_CONTENTS.NOTES && (
                                    <div style={{ marginLeft: "12px" }}>
                                        <ButtonWithLabel
                                            icon="attach_file"
                                            iconType="material"
                                            variant="l3rnTech"
                                            buttonStyle="borderless"
                                            style={{ alignItems: "end" }}
                                            labelStyle={{ lineHeight: "normal" }}
                                            label={`${profile?.attachments?.length || 0} Attached Files`}
                                            // onClick={() => setShowFilesAndAttachments(!showFilesAndAttachments)}
                                            hover={false}
                                        />
                                    </div>
                                )}
                            </div>
                            <ButtonWithText
                                label="Close"
                                icon="close"
                                iconType="material"
                                variant="passive"
                                size="medium"
                                buttonStyle="borderless"
                                hover={false}
                                onClick={() => {
                                    setState((prevState) => ({
                                        ...prevState,
                                        popupIsOpen: false,
                                        editMode: false,
                                        dealObject: initialDealObject,
                                    }));
                                    // setShowFilesAndAttachments(false);
                                    // setSelectedDeal(null);
                                }}
                            />
                        </ExtensionPopupHeader>
                        <ExtensionPopupContent variant={popupContent}>
                            {popupContent === POPUP_CONTENTS.ABOUT ? (
                                <ExtensionAboutPage />
                            ) : popupContent === POPUP_CONTENTS.COURSES ? (
                                <ExtensionCoursesPage />
                            ) : popupContent === POPUP_CONTENTS.DEALS ? (
                                <ExtensionDealsPage wonDeals={wonDeals} />
                            ) : popupContent === POPUP_CONTENTS.NEW_DEAL ? (
                                <ExtensionNewDealPage wonDeals={wonDeals} />
                            ) : popupContent === POPUP_CONTENTS.TRANSFER_DEAL ? (
                                <ExtensionNewDealPage wonDeals={wonDeals} />
                            ) : popupContent === POPUP_CONTENTS.NOTES ? (
                                showFilesAndAttachments ? (
                                    <ExtensionFilesAndAttachments
                                        onBack={() => setShowFilesAndAttachments(false)}
                                        showBackButton={true}
                                    />
                                ) : (
                                    <></>
                                    // <ExtensionNotesPage />
                                )
                            ) : popupContent === POPUP_CONTENTS.NEW_TASK ? (
                                <ExtensionNewTaskPage />
                            ) : popupContent === POPUP_CONTENTS.PROFILE_TASKS ? (
                                <ExtensionProfileTasksPage />
                            ) : popupContent === POPUP_CONTENTS.AI_ASSISTANT ? (
                                <ExtensionAIAssistantPage />
                            ) : popupContent === POPUP_CONTENTS.ASSISTANT ? (
                                <ExtensionAssistantPage />
                            ) : null}
                        </ExtensionPopupContent>
                        {popupContent === "Deals" && (
                            <ExtensionPopupFooter>
                                <DealFooter />
                            </ExtensionPopupFooter>
                        )}
                        {popupContent === "Profile Tasks" && (
                            <ExtensionPopupFooter>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <div></div>
                                    <ButtonWithText
                                        variant="l3rnTech"
                                        size="small"
                                        buttonStyle="default"
                                        onClick={() => {
                                            setState({
                                                popupContent: POPUP_CONTENTS.NEW_TASK,
                                                popupIsOpen: true,
                                                taskPage: false,
                                                editMode: false,
                                            });
                                        }}
                                    >
                                        Add New Task
                                    </ButtonWithText>
                                </div>
                            </ExtensionPopupFooter>
                        )}
                    </ExtensionPopup>
                </ExpandingPopup>

                {isLoadingSalesNavigator ? (
                    <LoadingSalesNavigator />
                ) : (
                    <ExtensionContainer>
                        <ExtensionHeaderActions
                            isSearchVisible={isSearchVisible}
                            setIsDeleteModalOpen={setIsDeleteModalOpen}
                            toggleSearch={toggleSearch}
                            setIsPopitSearch={setIsPopitSearch}
                            isPopitSearch={isPopitSearch}
                            searchInputOptionClick={searchInputOptionClick}
                            profile={profile}
                        />

                        <ExtensionContentWrapper reserveAssistantSpace={canAsk}>
                            <>
                                {(isProfileLoading || updateProfileLoading || loading) && (
                                    <ProfileLoadingOverlay isSolidBackground={profile ? false : true}>
                                        <Spinner size={32} thickness={4} variant="l3rnTech" />
                                    </ProfileLoadingOverlay>
                                )}
                                <div
                                    style={{
                                        padding: "0px 12px",
                                        marginBottom: "12px",
                                    }}
                                >
                                    <Tabs
                                        options={options}
                                        selected={selectedTab}
                                        setSelected={(selected) => {
                                            setState((prevState) => ({
                                                ...prevState,
                                                selectedTab: selected,
                                                popupIsOpen: false,
                                                editMode: false,
                                            }));
                                        }}
                                    />
                                </div>
                                {selectedTab === "Profile" ? (
                                    <>
                                        <div
                                            style={{
                                                overflowY: "scroll",
                                                position: "relative",
                                                height: "100%",
                                                paddingBottom: "var(--assistant-orb-space, 0px)",
                                            }}
                                            id="profile-container"
                                        >
                                            <FloatingNameBox show={showFloatingName}>
                                                <ImageSection size="52px">
                                                    <ImageBorder style={{ position: "relative" }}>
                                                        <Image
                                                            src={
                                                                urlParams?.profil_resim &&
                                                                !urlParams?.profil_resim.startsWith("data:image")
                                                                    ? urlParams?.profil_resim
                                                                    : profile?.resim || fallbackSrc
                                                            }
                                                            alt="profile"
                                                            onError={(e) => (e.currentTarget.src = fallbackSrc)}
                                                        />
                                                    </ImageBorder>
                                                </ImageSection>
                                                <div>
                                                    <OverlayTrigger
                                                        key="name"
                                                        overlay={
                                                            <StyledTooltip id={`tooltip-name`}>
                                                                {`${profile?.ad || ""} ${profile?.soyad || ""}`}
                                                            </StyledTooltip>
                                                        }
                                                    >
                                                        <FloatingName onClick={handleScrollToTop}>
                                                            {`${profile?.ad || ""} ${profile?.soyad || ""}`}
                                                        </FloatingName>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                        key="title"
                                                        placement="bottom"
                                                        overlay={
                                                            <StyledTooltip id={`tooltip-title`}>
                                                                {`${profile?.accountName || ""}`} |{" "}
                                                                {`${profile?.baslik || ""}`}
                                                            </StyledTooltip>
                                                        }
                                                    >
                                                        <FloatingTitle onClick={handleScrollToTop}>
                                                            {`${profile?.accountName || ""}`} |{" "}
                                                            {`${profile?.baslik || ""}`}
                                                        </FloatingTitle>
                                                    </OverlayTrigger>
                                                </div>
                                            </FloatingNameBox>

                                            <div
                                                style={{
                                                    padding: "0px 12px",
                                                    marginBottom: "12px",
                                                    marginTop: "-75px",
                                                }}
                                            >
                                                <ProfileCard />
                                            </div>

                                            <div
                                                style={{
                                                    // height: `calc(100% - ${getProfileContentHeight()}px)`,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    flex: 1,
                                                    gap: "0px",
                                                    paddingLeft: "10px",
                                                    paddingRight: "5px",
                                                    overflowY: "visible",
                                                }}
                                            >
                                                <ExtensionCourseCard />
                                                <ExtensionDealCard />
                                                <div ref={taskRef}>
                                                    <ExtensionTaskCard setTaskToDelete={setTaskToDelete} />
                                                </div>
                                                <div ref={typeTagRef}>
                                                    <TypeTag />
                                                </div>
                                                <ExtensionNoteCard
                                                    showFilesAndAttachments={showFilesAndAttachments}
                                                    setShowFilesAndAttachments={setShowFilesAndAttachments}
                                                />
                                            </div>
                                        </div>
                                    </>
                                ) : selectedTab === "Feed" ? (
                                    <>
                                        <ExtensionFeedList />
                                    </>
                                ) : selectedTab === "Tasks" ? (
                                    <>
                                        <ExtensionTaskList
                                            taskList={taskList}
                                            taskListLoading={taskListLoading}
                                            setTaskToDelete={setTaskToDelete}
                                        />
                                    </>
                                ) : (
                                    selectedTab === "New Lead" && (
                                        <>
                                            <ExtensionNewLead />
                                        </>
                                    )
                                )}
                            </>

                            {/* The assistant's door: an orb over the panel, opening the assistant's
                                own popup beside it. Not tied to a tab — the assistant answers on the
                                account's data, not on whatever tab you happen to be reading.

                                Hidden whenever a popup is already open, including its own: every popup
                                already has its own header Close button, and the popup renders as a
                                flex sibling of this panel rather than over it. */}
                            {canAsk && !popupIsOpen && (
                                <ExtensionAssistantLauncher
                                    isOpen={isAssistantOpen}
                                    onOpen={() =>
                                        setState((prevState) => ({
                                            ...prevState,
                                            popupContent: POPUP_CONTENTS.ASSISTANT,
                                            popupIsOpen: true,
                                        }))
                                    }
                                    onClose={() => setState((prevState) => ({ ...prevState, popupIsOpen: false }))}
                                />
                            )}
                        </ExtensionContentWrapper>
                    </ExtensionContainer>
                )}
                <div id="newFilterMenu" />
            </ExtensionWithPopup>

            {showMailModal && (
                <MailContentModal onClick={closeMailModal} ref={mailContentRef}>
                    <MailContentContainer onClick={(e) => e.stopPropagation()}>
                        <MailContentHeader>
                            <h4>Email Content</h4>
                            <ButtonWithText
                                label="Close"
                                icon="close"
                                iconType="material"
                                variant="passive"
                                size="medium"
                                buttonStyle="borderless"
                                hover={false}
                                onClick={closeMailModal}
                            />
                        </MailContentHeader>
                        <MailContentBody
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(mailContent, { ADD_ATTR: ["target", "rel"] }),
                            }}
                        />
                    </MailContentContainer>
                </MailContentModal>
            )}

            <Modal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                title="Are you sure you want to delete this profile?"
                variant="danger"
                icon="delete"
                successButtonText="Yes, Delete"
                cancelButtonText="Not Now"
                onSuccess={handleProfileDelete}
            >
                <div>All related notes and tasks will be also deleted. </div>
                <div>This action cannot be undone.</div>
            </Modal>
            <Modal
                isOpen={selectedModal === modals.DELETE_TASK}
                successButtonText="Yes, Delete"
                cancelButtonText="Not Now"
                onClose={() =>
                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                    }))
                }
                title={modalMessage ? modalMessage : "Are you sure you want to delete this file?"}
                variant="danger"
                icon="delete"
                onSuccess={() => {
                    handleTaskDelete(taskToDelete);
                    //refetchProfile();
                    refetchTaskList();

                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                    }));
                }}
            >
                <div>This action cannot be undone.</div>
            </Modal>
            <Modal
                isOpen={selectedModal === modals.DELETE_DEAL}
                onClose={() =>
                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                    }))
                }
                title={
                    parseFloat(selectedDeal?.paidAmount) > 0
                        ? `This deal includes $${parseFloat(selectedDeal?.paidAmount).toFixed(
                              2
                          )} payment. Deleting it will also remove the payment permanently.`
                        : "Are you sure you want to delete this deal?"
                }
                variant="danger"
                icon="delete"
                successButtonText="Yes, Delete"
                cancelButtonText="Not Now"
                onSuccess={async () => {
                    handleDeleteDeal(selectedDeal?.id);
                }}
            >
                <div>This action cannot be undone.</div>
            </Modal>
            <Modal
                isOpen={selectedModal === modals.DELETE_BASED_ON_STATUS}
                onClose={() =>
                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                    }))
                }
                title="Delete Deal"
                variant="danger"
                icon="delete"
                successButtonText="Okay"
                onSuccess={() => {
                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                    }));
                }}
            >
                <div>Deal cannot be deleted without status cancelled</div>
            </Modal>
            <Modal
                isOpen={selectedModal === modals.LINKEDIN_URL_UPDATE}
                onClose={() =>
                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                        updateProfileParams: null,
                    }))
                }
                title="Are you sure you want to change the LinkedIn URL of this profile?"
                variant="warning"
                icon="warning"
                successButtonText="Yes"
                cancelButtonText="No"
                onSuccess={() => {
                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                    }));
                    handleUpdateProfile({
                        field: updateProfileParams.field,
                        fieldValue: updateProfileParams.fieldValue,
                    });
                }}
            >
                <div>The LinkedIn URL will be updated to </div>
                <a
                    href={`https://www.linkedin.com/in/${updateProfileParams?.fieldValue}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://www.linkedin.com/in/{updateProfileParams?.fieldValue}
                </a>
            </Modal>
            <Modal
                isOpen={isKeyContactModalOpen}
                onClose={() => setIsKeyContactModalOpen(false)}
                title={
                    profile?.keyContactStatus === 1
                        ? "Do you approve to set this profile as Key-Contact?"
                        : "Do you approve to remove Key-Contact from this profile?"
                }
                variant="l3rnTech"
                icon="link"
                successButtonText="Approve"
                cancelButtonText="Cancel"
                rejectButtonText="Decline"
                onSuccess={() => handleKeyContactStatusChange("approve")}
                onReject={() => handleKeyContactStatusChange("decline")}
            />
        </>
    );
}

function ExtensionHome(props) {
    return (
        <ExtensionProvider extensionEvents={{}}>
            <ExtensionHomeContent {...props} />
        </ExtensionProvider>
    );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { ...auth.actions };

export default connect(mapStateToProps, mapDispatchToProps)(ExtensionHome);
